export class CreateDriverJsonModel {
  // MotoristaRegisterObj
  public Nome: string = ''
  public Cpf: string = ''
  public Email: string = ''
  public Senha: string = ''
  public Matricula: string = ''
  public DataNascimento: string = ''
  public DataContratacao: string = ''
  public StatusId: number = 0
  public TipoMotoristaId: number = 0
  public NumeroRegistro: string = ''
  public Categoria: string = ''
  public Validade: string = ''
  public IsFuncionario: 'S' | 'N' = 'N'

  //fornecedor
  public FornecedorId: number | null = null
  public IsAutonomo: 'S' | 'N' = 'N'
  public Cnpj: string = ''
  public InscricaoEstadual: string = ''
  public InscricaoMunicipal: string = ''
  public NomeFantasia: string = ''
  public RazaoSocial: string = ''
  public FornecedorExiste: 'S' | 'N' = 'N'

  // MotoristaEnderecoRegisterObj
  public TipoEnderecoId: number = 0
  public Cep: string = ''
  public Logradouro: string = ''
  public Numero: string = ''
  public Complemento: string = ''
  public Bairro: string = ''
  public Estado: string = ''
  public Cidade: string = ''
  public Pais: string = ''
  public Latitude: string = ''
  public Longitude: string = ''

  // MotoristaContatoObj
  public Contatos: contact[] = []

  // MotoristaUploadObj
  public Files: file[] = []
}

export class EditDriverModel {
  public id: number = 0
  public descricao: string = ''
}

export class DeleteDriverModel {
  public id: number = 0
  public descricao: string = ''
}

export class SearchDriverModel {
  public descricao: string = ''
}

export class CreateDriverResponse {
  public response: any
}
export class EditDriverResponse {
  public response: any
}
export class DeleteDriverResponse {
  public response: any
}
export class PagedDriverResponse {
  public response: any
}
export class CreateDriverModel extends CreateDriverJsonModel {
  public toFormData(): FormData {
    const formData = new FormData()

    // MotoristaRegisterObj
    formData.append('MotoristaRegisterObj.Nome', this.convertString(this.Nome))
    formData.append('MotoristaRegisterObj.Cpf', this.convertString(this.Cpf))
    formData.append(
      'MotoristaRegisterObj.Email',
      this.convertString(this.Email),
    )
    formData.append(
      'MotoristaRegisterObj.Senha',
      this.convertString(this.Senha),
    )
    formData.append(
      'MotoristaRegisterObj.Matricula',
      this.convertString(this.Matricula),
    )
    formData.append(
      'MotoristaRegisterObj.DataNascimento',
      this.convertString(this.DataNascimento),
    )
    formData.append(
      'MotoristaRegisterObj.DataContratacao',
      this.convertString(this.DataContratacao),
    )
    formData.append(
      'MotoristaRegisterObj.StatusId',
      this.convertString(this.StatusId),
    )
    formData.append(
      'MotoristaRegisterObj.TipoMotoristaId',
      this.convertString(this.TipoMotoristaId),
    )
    formData.append(
      'MotoristaRegisterObj.NumeroRegistro',
      this.convertString(this.NumeroRegistro),
    )
    formData.append(
      'MotoristaRegisterObj.Categoria',
      this.convertString(this.Categoria),
    )
    formData.append(
      'MotoristaRegisterObj.Validade',
      this.convertString(this.Validade),
    )
    formData.append(
      'MotoristaRegisterObj.IsFuncionario',
      this.convertString(this.IsFuncionario),
    )

    // Info Fornecedor
    formData.append(
      'MotoristaRegisterObj.FornecedorId',
      this.convertString(this.FornecedorId),
    )
    formData.append(
      'MotoristaRegisterObj.IsAutonomo',
      this.convertString(this.IsAutonomo),
    )
    formData.append('MotoristaRegisterObj.Cnpj', this.convertString(this.Cnpj))
    formData.append(
      'MotoristaRegisterObj.InscricaoEstadual',
      this.convertString(this.InscricaoEstadual),
    )
    formData.append(
      'MotoristaRegisterObj.InscricaoMunicipal',
      this.convertString(this.InscricaoMunicipal),
    )
    formData.append(
      'MotoristaRegisterObj.NomeFantasia',
      this.convertString(this.NomeFantasia),
    )
    formData.append(
      'MotoristaRegisterObj.RazaoSocial',
      this.convertString(this.RazaoSocial),
    )
    formData.append(
      'MotoristaRegisterObj.FornecedorExiste',
      this.convertString(this.FornecedorExiste),
    )

    // MotoristaEnderecoRegisterObj
    formData.append(
      'MotoristaEnderecoRegisterObj.TipoEnderecoId',
      this.convertString(this.TipoEnderecoId),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Cep',
      this.convertString(this.Cep),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Logradouro',
      this.convertString(this.Logradouro),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Numero',
      this.convertString(this.Numero),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Complemento',
      this.convertString(this.Complemento),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Bairro',
      this.convertString(this.Bairro),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Estado',
      this.convertString(this.Estado),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Cidade',
      this.convertString(this.Cidade),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Pais',
      this.convertString(this.Pais),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Latitude',
      this.convertString(this.Latitude),
    )
    formData.append(
      'MotoristaEnderecoRegisterObj.Longitude',
      this.convertString(this.Longitude),
    )

    // MotoristaContatoObj
    if (this.Contatos) {
      for (let index = 0; index < this.Contatos.length; index++) {
        let contato = this.Contatos[index]
        if (contato.tipoContatoId >= 0 && contato.descricao) {
          formData.append(
            `MotoristaContatoObj[${index}].TipoContatoId`,
            this.convertString(contato.tipoContatoId),
          )
          formData.append(
            `MotoristaContatoObj[${index}].Descricao`,
            this.convertString(contato.descricao),
          )
        }
      }

      // for (const contato of this.Contatos) {
      //   if (contato.TipoContatoId >= 0 && contato.Descricao) {
      //     formData.append(
      //       `MotoristaContatoObj[${index}].TipoContatoId`,
      //       this.convertString(contato.TipoContatoId),
      //     )
      //     formData.append(
      //       'MotoristaContatoObj.Descricao',
      //       this.convertString(contato.Descricao),
      //     )
      //   }
      // }
    }

    // MotoristaUploadObj
    if (this.Files) {
      for (let index = 0; index < this.Files.length; index++) {
        let file = this.Files[index]
        if (file.TipoDocId >= 0 && file.Descricao && file.Arquivo) {
          formData.append(
            `MotoristaUploadObj[${index}].TipoDocId`,
            this.convertString(file.TipoDocId),
          )
          formData.append(
            `MotoristaUploadObj[${index}].Descricao`,
            this.convertString(file.Descricao),
          )
          formData.append(`MotoristaUploadObj[${index}].Arquivo`, file.Arquivo)
        }
      }
      // for (const file of this.Files) {
      //   if (file.TipoDocId >= 0 && file.Descricao && file.Arquivo) {
      //     formData.append(
      //       'MotoristaUploadObj.TipoDocId',
      //       this.convertString(file.TipoDocId),
      //     )
      //     formData.append(
      //       'MotoristaUploadObj.Descricao',
      //       this.convertString(file.Descricao),
      //     )
      //     formData.append('MotoristaUploadObj.Arquivo', file.Arquivo)
      //   }
      // }
    }

    return formData
  }

  private convertString(value: any) {
    return value ? value.toString() : ''
  }
}

class contact {
  public tipoContatoId: number = 0
  public descricao: string = ''
}

class file {
  public TipoDocId: number = 0
  public Descricao: string = ''
  public Arquivo: File | null = null
}
